import React from 'react'
import { Wrap } from 'shared/components/Base/Base'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { SimpleDialog } from 'shared/components/Dialog/SimpleDialog'
import { Text } from 'shared/components/Text/Text'
import { Handler } from 'shared/helpers/typeHelper'

interface ConfirmSingleDeleteProps {
  onSuccess: Handler
  onClose: Handler
  headlineLabel: string
  confirmLabel: string
  isLoading: boolean
}

export function ConfirmSingleDelete({
  onSuccess,
  onClose,
  confirmLabel,
  headlineLabel,
  isLoading,
}: ConfirmSingleDeleteProps) {
  return (
    <SimpleDialog onClose={onClose} isOpen hasBigPadding maxWidth="472px">
      <Wrap width="700px" maxWidth="100%">
        <Text variant="header2" align="left" mt={4}>
          {headlineLabel}
        </Text>

        <Box mt={8} />
        <Button margin="0 auto" variant="primary" size="large" onClick={onSuccess} isLoading={isLoading}>
          {confirmLabel}
        </Button>
        <Box m={3} />
        <Button margin="0 auto" variant="text" onClick={onClose}>
          Cancel
        </Button>
      </Wrap>
    </SimpleDialog>
  )
}
